import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Container, Row, Col } from '../../../../../SPRINTA/atoms/Grid'
import Font from '../../../../../SPRINTA/atoms/Font'
import Loading from '../../../../../SPRINTA/atoms/Loading'
import Placeholder from '../../../../../SPRINTA/atoms/PlaceHolder'
import BoxEvent from '../../../../../SPRINTA/molecules/BoxEvent'
import * as user from '../../../../utils/user'
import Button from '../../../../../SPRINTA/atoms/Button'

import T from '../../../../../SPRINTA/translate/T'


class Events extends Component {
   state = {
      loadingPast: true,
      dataPast: [],
      totalPast: 0,
      loadingMorePast: false,
      loadingFuture: true,
      dataFuture: [],
      totalFuture: 0,
      loadingMoreFuture: false
   }

   componentWillMount() {
      this.componentWillReceiveProps(this.props, true)   
   }

   componentWillReceiveProps(nextProps, force = false) {
      if(this.props.username !== nextProps.username || this.props.type !== nextProps.type || force) {
            this.loadDataPast(nextProps.username, 0)
            this.loadDataFuture(nextProps.username, 0)
            this.setState({
                  loadingPast: true
            })
      }
   }

   loadDataPast(username, start = 0, limit = 12) {
      this.setState({
            loadingMore: true
      })

      user.eventsPast(username, start, limit)
      .then(data => {
         this.setState({
            loadingPast: false,
            totalPast: data.result.total,
            dataPast: [
                  ...this.state.dataPast,
                  ...data.result.list
            ],
            loadingMorePast: false
         })
      })
   }

   loadMoreDataPast() {
      this.setState({
            loadingMorePast: true
      })

      this.loadDataPast(this.props.username, this.state.dataPast.length)
   }

   loadDataFuture(username, start = 0, limit = 12) {
      this.setState({
            loadingMore: true
      })

      user.eventsFuture(username, start, limit)
      .then(data => {
         this.setState({
            loadingFuture: false,
            totalFuture: data.result.total,
            dataFuture: [
                  ...this.state.dataFuture,
                  ...data.result.list
            ],
            loadingMoreFuture: false
         })
      })
   }

   loadMoreDataFuture() {
      this.setState({
            loadingMoreFuture: true
      })

      this.loadDataFuture(this.props.username, this.state.dataFuture.length)
   }


   render() {
      if(this.state.loadingPast || this.state.loadingFuture)
      return(
         <Container>
            <Row>
               <Col>
                  <Placeholder type='retangle' style={{width: '200px', marginTop: '20px', height: '40px'}} />
                  <Row>
                     <Col size='12 4'>
                        <Placeholder type='retangle' style={{marginTop: '20px', height: '150px'}} />
                     </Col>
                     <Col size='12 4'>
                        <Placeholder type='retangle' style={{marginTop: '20px', height: '150px'}} />
                     </Col>
                     <Col size='12 4'>
                        <Placeholder type='retangle' style={{marginTop: '20px', height: '150px'}} />
                     </Col>
                  </Row>
                  <br />
               </Col>
            </Row>
         </Container>
      )

      return (
         <Container style={{paddingBottom: '30px'}}>
            {this.state.dataFuture.length > 0 && (
                  <Row>
                        <Col>
                              <Row>
                                    <Col size='6'>
                                          <Font heading="3" color='#666' weight='100' style={{margin: '30px 0'}}>
                                          {T.text('future_events_b')}
                                          </Font>
                                    </Col>
                              </Row>
                              <Row>
                                    {this.state.dataFuture.map(item => (
                                          <Col size='12 4' key={item.id} style={{marginTop: '30px'}}>
                                                <a href={`/${item.kind}/${item.token}`}>
                                                      <BoxEvent
                                                            data={{
                                                                  cover: item.coverImagePath || null,
                                                                  type: item.kind,
                                                                  date: item.startDate,
                                                                  state_abbreviation: item.region,
                                                                  city: item.city,
                                                                  title: item.title,

                                                            }}
                                                      />
                                                </a>
                                          </Col>
                                    ))}
                              </Row>
                              {this.state.dataFuture.length < this.state.totalFuture && (
                                    <Col text='center' style={{marginTop: '30px'}}>
                                          {!this.state.loadingMoreFuture ? (
                                                <Button
                                                inline
                                                theme='primary'
                                                onClick={() => this.loadMoreDataFuture()}>
                                                      {T.txt('load_more')}
                                                </Button>
                                          ) : (
                                                <Loading />
                                          )}
                                    </Col>
                              )}
                        </Col>
                  </Row>
            )}
            {this.state.dataPast.length > 0 && (
                  <Row>
                        <Col>
                              <Row>
                                    <Col size='6' style={{marginTop: '60px'}}>
                                          <Font heading="3" color='#666' weight='100' style={{margin: '30px 0'}}>
                                                {T.text('past_events_b')}
                                          </Font>
                                    </Col>
                              </Row>
                              <Row>
                                    {this.state.dataPast.map(item => (
                                          <Col size='12 4' key={item.id} style={{marginTop: '30px'}}>
                                                <a href={`/${item.kind}/${item.token}`}>
                                                      <BoxEvent
                                                            data={{
                                                                  cover: item.coverImagePath || null,
                                                                  type: item.kind,
                                                                  date: item.startDate,
                                                                  state_abbreviation: item.region,
                                                                  city: item.city,
                                                                  title: item.title,

                                                            }}
                                                      />
                                                </a>
                                          </Col>
                                    ))}
                              </Row>
                              {this.state.dataPast.length < this.state.totalPast && (
                                    <Col text='center' style={{marginTop: '30px'}}>
                                          {!this.state.loadingMorePast ? (
                                                <Button
                                                inline
                                                theme='primary'
                                                onClick={() => this.loadMoreDataPast()}>
                                                      {T.txt('load_more')}                                          
                                                </Button>
                                          ) : (
                                                <Loading />
                                          )}
                                    </Col>
                              )}
                        </Col>
                  </Row>
            )}

         </Container>
      )
   }
}

const mapStateToProps = store => ({
   user: store.user
})
const mapDispatchToProps = {

}
export default connect( mapStateToProps, mapDispatchToProps )(Events)


// WEBPACK FOOTER //
// ./src/App/pages/Profile/Pages/Events/index.js